// extracted by css-extract-rspack-plugin
export default {"root":"oTp4jL1fDqAydIu3"};